export const cyan = '#0089cf'
export const darkBlue = '#1D0E46'
export const black = '#222'
export const teal = '#3c6485'
export const burgundy = '#83004c'
export const aqua = '#28c3c6'
export const lightBlue = '#96c6e9' // #a9d0ec - original
export const grey = '#8495a2'



export default {
  cyan,
  darkBlue,
  black,
  teal,
  aqua,
  burgundy,
  lightBlue,
  grey
}